import React, { useState, useRef } from 'react';
import './css/Contactform.css';
import { IoSendSharp, IoLocationSharp, IoMailSharp, IoCallSharp } from "react-icons/io5";
import AnimateInView from './AnimateInView';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import emailjs from '@emailjs/browser';

const Contactform = () => {
    const form = useRef();
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        enquiry: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.name || !formData.email || !formData.message) {
            toast.error('Please fill in all required fields');
            return;
        }

        emailjs.sendForm(
            'service_4bk31cc', // Replace with your Service ID
            'template_zk7c73p', // Replace with your Template ID
            form.current,
            'hivH6MldS5WT4vniy' // Replace with your Public Key
        )
        .then((result) => {
            toast.success('Message sent successfully!');
            setFormData({
                name: '',
                phone: '',
                email: '',
                enquiry: '',
                message: ''
            });
        })
        .catch((error) => {
            toast.error('Failed to send message. Please try again.');
            console.error('EmailJS Error:', error);
        });
    };

    return (
        <section className='contact-form-container'>
            <AnimateInView delay={0.2}>
                <div className='contact-form-container-content1'>
                    <form ref={form} className='contact-form-container-content1-content1' onSubmit={handleSubmit}>
                        <h1 className='heading-contact-form'>Contact Us</h1>
                        <div className='inputs-container'>
                            <div className='input-container-two'>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder='Name *'
                                    className='button-89 width-100'
                                />
                                <input
                                    type="number"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    placeholder='Phone Number'
                                    className='button-89 width-100'
                                />
                            </div>
                            <div className='input-container-two'>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder='Your Gmail *'
                                    className='button-89 width-100'
                                />
                                <input
                                    type="text"
                                    name="enquiry"
                                    value={formData.enquiry}
                                    onChange={handleChange}
                                    placeholder='Enquiry'
                                    className='button-89 width-100'
                                />
                            </div>
                            <textarea
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                placeholder='Message *'
                                className='button-89 width-100 height-text-area'
                            />
                            <button className='button-89 width-100 submit-btn'>
                                Submit <IoSendSharp className="submit-icon" />
                            </button>
                        </div>
                    </form>

                    <div className='contact-form-container-content1-content2'>
                        <h2 className='heading-contact-form-content2'>communication</h2>
                        <div className='contact-form-container-content1-content2-content1'>
                            <div>
                                <p className='paragraph change-font-color'>
                                    <IoLocationSharp className="contact-icon" /> Address:
                                </p>
                                <p className='paragraph change-font-color'> HPA-R3-SCO-023, DLF HYDE PARK ESTATE, New Chandigarh, Mullanpur, Punjab-140901</p>
                            </div>
                            <div>
                                <p className='paragraph change-font-color'>
                                    <IoMailSharp className="contact-icon" /> Mail us:
                                </p>
                                <p className='paragraph change-font-color'> dhimanwoodwork41@gmail.com</p>
                            </div>
                            <div>
                                <p className='paragraph change-font-color'>
                                    <IoCallSharp className="contact-icon" /> call us:
                                </p>
                                <p className='paragraph change-font-color'> +91 9814562530 , +91 7807462535,+91 82858 70007</p>
                            </div>
                        </div>
                    </div>
                </div>
            </AnimateInView>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />
        </section>
    );
};

export default Contactform;
